// This file is AI generated.
import type { ErrorEvent, EventHint } from '@sentry/nextjs'

/**
 * Next.js sets `digest` on errors thrown while rendering on the server. In
 * production the browser only receives a generic message plus this digest, so
 * it is the only key shared by the server event and its client-side copy.
 */
export function getErrorDigest(error: unknown): string | undefined {
  if (typeof error !== 'object' || error === null) return undefined
  const { digest } = error as { digest?: unknown }

  return typeof digest === 'string' && digest ? digest : undefined
}

/**
 * Client `beforeSend`: tags the browser copy of a server render error with its
 * digest and groups all of them in one issue. The server event carries the
 * same `digest` tag, so `digest:<value>` (or the shared trace) leads to the
 * issue with the real stack trace.
 */
export function tagServerRenderError(
  event: ErrorEvent,
  hint: EventHint,
): ErrorEvent {
  const digest = getErrorDigest(hint.originalException)
  if (!digest) return event

  return {
    ...event,
    tags: { ...event.tags, digest },
    fingerprint: ['server-render-error', '{{ error.value }}'],
  }
}
